import {
  AsyncCreatableSelectField,
  CustomCreatableSelectField,
} from './CreatableSelect';
import { CreatableSelectField } from './CreatableSelect';
import {
  InputField,
  InputWithGenerate,
  InputInlineEdit,
  PlainInput,
  TagInput,
} from './InputFields';
import { SelectField } from './SelectField';
import { TextareaField } from './TextareaField';
import { RadioGroupField } from './RadioGroupField';
import { RadioGroupFieldV2 } from './RadioGroupFieldV2';
import { UploadField } from './UploadField';
import { FormEditor } from './FormEditor';
import { MenuField } from './MenuField';
import { CheckboxField } from './CheckboxField';
import { AsyncSelectField } from './AsyncSelectField';
import { DateField } from './DateField';
import { SliderField } from './SliderField';
import { MonthYearField } from './MonthYearField/MonthYearField';
import { StarField } from './StarField';
import { RatingField } from './RatingField';
import { CheckboxGroupField } from './CheckboxGroupField';
import { KPhoneField } from './KPhoneField';
import { SwitchField } from './SwitchField';
import { DateFieldWithTZ } from './DateField/DateFieldWithTZ';
import { FilterDatePicker } from './DateField/FilterDatePicker';
import { VariableInlineEditor } from './FormEditor/VariableInlineEditor';
import { FilterDateRangePicker } from './DateField/FilterDateRangePicker';
import { KSelectField } from '@/ui-library/components/organisms/KFields/KSelectField';
import { KInputField } from '@/ui-library/components/organisms/KFields/KInputField';
import { KAutoComplete } from '@/ui-library/components/organisms/KFields/KAutoComplete';
import { DependentSelectField } from './DependentSelectField';
export { FormEditor } from './FormEditor';
export { ConditionalFields } from './ConditionalFields';

export const formFieldComponents = {
  input: InputField,
  plainInput: PlainInput,
  tagInput: TagInput,
  variableInput: VariableInlineEditor,
  inputWithGenerate: InputWithGenerate,
  inputWithEdit: InputInlineEdit,
  textArea: TextareaField,
  select: SelectField,
  asyncSelect: AsyncSelectField,
  filterDatePicker: FilterDatePicker,
  filterDateRangePicker: FilterDateRangePicker,
  selectWithCreate: CreatableSelectField,
  asyncSelectWithCreate: AsyncCreatableSelectField,
  selectWithCreateV1: CustomCreatableSelectField,
  // old: legacy for backward compatibility
  radio: RadioGroupField,
  // new: using kula components
  radio2: RadioGroupFieldV2,
  upload: UploadField,
  editor: FormEditor,
  menu: MenuField,
  checkbox: CheckboxField,
  date: DateField,
  dateWithTimeZone: DateFieldWithTZ,
  slider: SliderField,
  monthYear: MonthYearField,
  star: StarField,
  rating: RatingField,
  checkboxGroup: CheckboxGroupField,
  phone: KPhoneField,
  switch: SwitchField,
  dependentSelect: DependentSelectField,
  // Add more types as needed...

  // new components
  // KFields

  kSelect: KSelectField,
  kInput: KInputField,
  autoComplete: KAutoComplete,
};
